import React, { useEffect } from 'react';
import { Button, Container, Row, Col, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import styles from '../../Measures.module.scss';
import { data } from '../../../data';

const PSITechnical = () => {
    useEffect(() => {
        // Update the document title using the browser API
        document.title = `AHRQ QI: PSI Technical Specifications Updates - Version v2019 (ICD 10-CM/PCS), July 2019`;
      });
    return (<>

        <Container className='outerContainer'>
            <h1 className="centerText mb-5">Patient Safety Indicators Technical Specifications</h1>
        </Container>
        <Container className='outerContainer'>
        <h3 className="mb-5">Patient Safety Indicators Technical Specifications Updates - Version v2019 (ICD 10-CM/PCS), July 2019</h3>
            <Row>
                <Col md={8}>
                    <h4>Updated Patient Safety Indicators Technical Specifications (PDF Format), Version 2019 (Zip File)</h4>
                </Col>
                <Col md={4} className={styles.downloadSpecBtn}>
                    <Button href='https://www.qualityindicators.ahrq.gov/Downloads/Modules/PSI/V2019/TechSpecs/PSI_2019_ICD10_techspecs_pdf.zip'>Download All (.zip)</Button>
                </Col>
            </Row>
            <hr />
        </Container>

        <Container className='outerContainer'>
            <Table striped hover>
                <tbody >
                    {data.modules.filter((module) => module.topictag == "PSI-Indicators").map((information) => (<>
                        {information.indicators.map((info) => (<>
                            {info.previous && info.previous.filter((prev) => prev.version == "Version 2019").map((prev) => (<>
                                <tr>
                                    <td><a href={prev.url}>{prev.name}</a></td>
                                </tr>
                            </>))}
                        </>))}
                        {information.appendices.appendix.filter((a) => a.version == "V2019")[0].children.map((row) =>
                            <tr>
                                <td><a href={row.url}>{row.name}</a></td>
                            </tr>
                        )}

                    </>))}
                </tbody>
            </Table>
        </Container>
        <Container className='outerContainer mt-5'>
            <h3>Retired Indicators</h3>
            <p><span className="danger">Effective v2019</span>, the following indicators have been retired. For additional information, refer to the retirement announcements: <a href="https://www.qualityindicators.ahrq.gov/News/Retirement%20Notice_v2019_Indicators.pdf">Indicators Retirement Announcement.</a></p>
            <ul>
                <li>PSI 16 Transfusion Reaction Count</li>
            </ul>
            <p><span className="danger">Effective v7.0</span>, the following indicators have been retired. For additional information, refer to the retirement announcements: <a href="https://www.qualityindicators.ahrq.gov/News/PSI_Retirement_Notice.pdf">PSI Area Level Hospital</a>.</p>
            <ul>
                <li>PSI 21 Retained Surgical Item or Unretrieved Device Fragment Rate</li>
                <li>PSI 22 Iatrogenic Pneumothorax Rate</li>
                <li>PSI 23 Central Venous Catheter-Related Blood Stream Infection Rate</li>
                <li>PSI 24 Postoperative Wound Dehiscence Rate</li>
                <li>PSI 25 Accidental Puncture or Laceration Rate</li>
                <li>PSI 26 Transfusion Reaction Rate</li>
                <li>PSI 27 Perioperative Hemorrhage or Hematoma Rate</li>
                </ul>
      
        </Container>
        <Container className='outerContainer mt-5'>
            <div className='p-3 light-container'>
                <p className='mb-0'>Patient Safety Indicators Technical Specifications for SAS and WinQI ICD-10 version v2018 can be found <Link to="../archive">here</Link> .</p>
            </div>
        </Container>

    </>)
}

export default PSITechnical;